import { defaultTheme } from '@yes.technology/react-toolkit'
import { CSSProperties } from 'react'
import styled from 'styled-components'

const MODAL_DEFAULT_ZINDEX = defaultTheme.zIndexes.modal

export const FullScreenWrapper = styled.div<{ zIndex?: number }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  min-width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  z-index: ${({ zIndex }) => zIndex ?? MODAL_DEFAULT_ZINDEX};
`

export const CardWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  margin: 0;
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex: 1;
  min-height: 0;

  header {
    padding: 0;
  }
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
  min-height: 0;
`

export const IframeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
`

export const cardStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  maxWidth: '1670px',
  maxHeight: 'calc(100vh - 32px)',
  margin: 0,
  padding: '32px',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  flex: 1
}
